/* eslint-disable no-unused-expressions, no-magic-numbers */

class Steps {

    /**
     * Make a new Tabs interface.
     * @constructs
     * @param {HTMLElement} element
     * @param {{}} options
     */
    constructor(element, options) {
        this._element = element;

        this._options = {
            ...options
        };

        this._state = {
            current: 0
        };

        this._rootContainer = document.body;
        this._handlePreviousStep = this._handlePreviousStep.bind(this);
        this._handleNextStep = this._handleNextStep.bind(this);
        this._cacheSelectors();
        this._initialize();
    }

    /**
     * Cache elements
     * @private
     */
    _cacheSelectors() {
        this._elements = {
            stepsContent: [...this._element.querySelectorAll('.steps__content')],
            stepsActions: [...this._element.querySelectorAll('.steps__actions')],
            stepsSvg: [...this._element.querySelectorAll('.steps__svg-item')]
        };
    }

    /**
     * Initialize
     * @private
     */
    _initialize() {
        this._addListeners();
    }

    /**
     * Add event listeners
     * @private
     */
    _addListeners() {
        this._elements.stepsActions.forEach(action => {
            const previousTrigger = action.querySelector('[data-action="back"]');
            const nextTrigger = action.querySelector('[data-action="next"]');
            previousTrigger && previousTrigger.addEventListener('click', event => this._handlePreviousStep(event));
            nextTrigger && nextTrigger.addEventListener('click', event => this._handleNextStep(event));
        });
    }

    /**
     * Go to previous step
     * @private
     * @param {*} event
     */
    _handlePreviousStep(event) {
        event.preventDefault();
        this._state.current = this._state.current > 0 ? this._state.current - 1 : this._state.current;
        this._setCurrentStep();
    }

    /**
     * Go to next step
     * @private
     * @param {*} event
     */
    _handleNextStep(event) {
        event.preventDefault();
        this._state.current = this._state.current < 2 ? this._state.current + 1 : this._state.current;
        this._setCurrentStep();
    }

    /**
     * Set the current step
     * @private
     */
    _setCurrentStep() {
        this._element.setAttribute('data-current-step', this._state.current);

        this._elements.stepsActions.forEach((action, index) => {
            const isCurrent = index === this._state.current;

            !isCurrent && action.setAttribute('hidden', '');
            !isCurrent && this._elements.stepsContent[index].setAttribute('hidden', '');
            // !isCurrent && this._elements.stepsSvg[index].setAttribute('data-active-step', 'false');

            isCurrent && action.removeAttribute('hidden');
            isCurrent && this._elements.stepsContent[index].removeAttribute('hidden');
            // IsCurrent && this._elements.stepsSvg[index].setAttribute('data-active-step', 'true');

        });

    }

}

export default Steps;
/* eslint-enable */
